import { combineReducers } from '@reduxjs/toolkit';

import common from '../common';
import cruises from './cruises';
import filter from './filter';
import labels from './labels';
import message from './message';
import sort from './sort';

// `common` is a slice seeded through `preloadedState`, so this is a plain reducer map rather
// than a factory taking a reducer — see the store factory beside it.
const cruiseListApp = combineReducers({
  common,
  cruises,
  filter,
  labels,
  message,
  sort,
});

export default cruiseListApp;
